import SectionHeading from './SectionHeading';
import { features } from '@/mocks/homeData';

export default function Features() {
  return (
    <section id="features" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <SectionHeading
            centered
            eyebrow="内容与体验特点"
            title="从浏览到找回，覆盖完整使用链路"
            desc="无论是想更快找到想看的内容，还是希望入口更稳定、更好找回，这两方面在本页都能得到说明。"
          />

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {features.map((feature) => (
              <article
                key={feature.title}
                className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-md bg-secondary-500 text-background-50">
                  <i className={`${feature.icon} text-2xl`}></i>
                </div>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{feature.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{feature.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}